import React from 'react';

const settingSidebarMenusData = [
  {
    id: '9.1.1',
    text: 'Company',
    url: 'company',
    icon: 'lab lab-company',
    priority: 100,
    status: 1,
  },
  {
    id: '9.1.0',
    text: 'License',
    url: 'license',
    icon: 'fa-solid fa-key',
    priority: 100,
    status: 1,
  },
  {
    id: '9.1.2',
    text: 'Site',
    url: 'site',
    icon: 'lab lab-site',
    priority: 100,
    status: 1,
  },
  {
    id: '9.1.3',
    text: 'Branches',
    url: 'branches',
    icon: 'lab lab-branches',
    priority: 100,
    status: 1,
  },
  {
    id: '9.1.4',
    text: 'Mail',
    url: 'mail',
    icon: 'lab lab-mail',
    priority: 100,
    status: 1,
  },
  {
    id: '9.1.5',
    text: 'Otp',
    url: 'otp',
    icon: 'lab lab-otp',
    priority: 100,
    status: 1,
  },
  {
    id: '9.1.5a',
    text: 'Third-Party & Shimbirr',
    url: 'shimbirr-auth',
    icon: 'fa-solid fa-qrcode',
    priority: 100,
    status: 1,
  },
  {
    id: '9.1.6',
    text: 'Notification',
    url: 'notification',
    icon: 'lab lab-notification',
    priority: 100,
    status: 1,
  },
  {
    id: '9.1.19',
    text: 'HRM',
    url: 'hrm',
    icon: 'lab lab-administrators',
    priority: 100,
    status: 1,
  },
  {
    id: '9.1.9',
    text: 'Theme',
    url: 'theme',
    icon: 'lab lab-theme',
    priority: 100,
    status: 1,
  },
  {
    id: '9.1.10',
    text: 'Currencies',
    url: 'currencies',
    icon: 'lab lab-currencies',
    priority: 100,
    status: 1,
  },
  {
    id: '9.1.11',
    text: 'Item Categories',
    url: 'item-categories',
    icon: 'lab lab-item-categories',
    priority: 100,
    status: 1,
  },
  {
    id: '9.1.12',
    text: 'Item Attributes',
    url: 'item-attributes',
    icon: 'lab lab-item-attributes',
    priority: 100,
    status: 1,
  },
  {
    id: '9.1.13',
    text: 'Taxes',
    url: 'taxes',
    icon: 'lab lab-taxes',
    priority: 100,
    status: 1,
  },
  {
    id: '9.1.14',
    text: 'Pages',
    url: 'pages',
    icon: 'lab lab-pages',
    priority: 100,
    status: 1,
  },
  {
    id: '9.1.15',
    text: 'Role Permissions',
    url: 'role',
    icon: 'lab lab-role-permissions',
    priority: 100,
    status: 1,
  },
  {
    id: '9.1.18',
    text: 'Payment Gateway',
    url: 'payment-gateway',
    icon: 'lab lab-payment-gateway',
    priority: 100,
    status: 1,
  },
];

export default settingSidebarMenusData;
